/* eslint-disable */
import React, { useState } from "react";
import { useNavigate } from "react-router";
import { useToken } from "./useToken";
import { Link } from "react-router-dom";
import Nav from "./Navigation.js";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [errorFields, setErrorFields] = useState([]);
  const { login } = useToken();
  const navigate = useNavigate();

const handleSubmit = async (event) => {
  event.preventDefault();
  try {
    await login(username, password);
    // Redirect only on successful login
    navigate("/");
  } catch (e) {
    console.error(e);
    setErrorMessage("Incorrect username or password");
    setErrorFields(["username", "password"]);
  }
};


  const handleInputChange = (event) => {
    const { id, value } = event.target;
    if (errorFields.includes(id)) {
      setErrorFields(errorFields.filter((field) => field !== id));
      setErrorMessage("");
    }
    if (id === "username") {
      setUsername(value);
    } else if (id === "password") {
      setPassword(value);
    }
  };

  const getFieldClassNames = (fieldId) => {
    return `w-full bg-black/40 border rounded-lg px-3 py-2 sm:px-4 sm:py-3 sm:text-lg text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-purple-500 ${
      errorFields.includes(fieldId) ? "border-red-500" : "border-purple-800/60"
    }`;
  };

  return (
    <div className="relative min-h-screen">
      <div
        className="fixed inset-0 -z-10 pointer-events-none"
        style={{
          background:
            "radial-gradient(900px 600px at 82% -8%, rgba(147,51,234,0.16), transparent 60%), " +
            "radial-gradient(1000px 700px at 8% 110%, rgba(88,28,135,0.22), transparent 60%), " +
            "#000",
        }}
      />
      <Nav />
      <div className="flex justify-center px-4 py-10">
        <div className="w-full max-w-md sm:max-w-lg md:max-w-xl">
          <div className="text-center font-primary text-3xl sm:text-4xl md:text-5xl text-white mb-6 sm:mb-8">
            Log In
          </div>

          <div className="bg-purple-950/20 border border-purple-800/60 rounded-lg p-6 sm:p-8 md:p-10">
            <form onSubmit={handleSubmit} className="flex flex-col gap-4 sm:gap-5">
              <div>
                <label className="block text-sm sm:text-base text-purple-200 font-medium mb-1">
                  Username
                </label>
                <input
                  placeholder="Username"
                  type="text"
                  id="username"
                  value={username}
                  onChange={handleInputChange}
                  className={getFieldClassNames("username")}
                />
              </div>

              <div>
                <label className="block text-sm sm:text-base text-purple-200 font-medium mb-1">
                  Password
                </label>
                <input
                  placeholder="Password"
                  type="password"
                  id="password"
                  value={password}
                  onChange={handleInputChange}
                  className={getFieldClassNames("password")}
                />
              </div>

              {errorMessage && (
                <p className="text-red-400 text-sm sm:text-base text-center">{errorMessage}</p>
              )}

              <button
                type="submit"
                className="bg-purple-700 hover:bg-purple-600 transition-colors text-white font-semibold py-2.5 sm:py-3 sm:text-lg rounded-lg"
              >
                Log In
              </button>

              <p className="text-center text-gray-400 text-xs sm:text-sm">
                Do not have an account?{" "}
                <Link className="text-purple-400 hover:text-purple-300" to="/signup">
                  Sign up
                </Link>
              </p>
            </form>
          </div>

          <p className="text-center text-gray-500 text-xs sm:text-sm mt-4">
            &copy;2030 Shanda LLC. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
